module.exports = __webpack_public_path__ + "static/aboutUs-640ca149f1bf16536c20a3e9046a6f9b.jpg";